import { SetState } from "../../lib/typeDeclarations";
import "./paginator.css";

type PaginatorType = {
  pages: number;
  currentPage: number;
  setPage: SetState;
};

export function Paginator({ pages, currentPage, setPage }: PaginatorType) {
  const array = Array.from({ length: pages }, (v, i) => i);
  const handleClick = (targetPage: number) => {
    if (targetPage > 0 && targetPage <= pages) {
      setPage({ page: targetPage });
    }
  };

  const onActive = (page: number) => {
    return Number(currentPage) === Number(page) + 1 ? "active" : "";
  };

  return (
    <div className="paginator">
      {array.length !== 1 && (
        <>
          <ul>
            <li>
              <button
                onClick={() => {
                  handleClick(Number(currentPage) - 1);
                }}>
                &lt;
              </button>
            </li>
            {array.length < 7 &&
              array.length !== 1 &&
              array.map((page) => (
                <li key={page} className={onActive(page)}>
                  <button
                    onClick={() => {
                      handleClick(page + 1);
                    }}>
                    {page + 1}
                  </button>
                </li>
              ))}
            {array.length >= 7 && (
              <>
                {array.slice(0, 3).map((page) => (
                  <li key={page}>
                    <button
                      onClick={() => {
                        handleClick(page + 1);
                      }}>
                      {page + 1}
                    </button>
                  </li>
                ))}
                <li>...</li>
                {array.slice(array.length - 3).map((page) => (
                  <li key={page}>
                    <button
                      onClick={() => {
                        handleClick(page + 1);
                      }}>
                      {page + 1}
                    </button>
                  </li>
                ))}
              </>
            )}
            <li>
              <button
                onClick={() => {
                  handleClick(Number(currentPage) + 1);
                }}>
                &gt;
              </button>
            </li>
          </ul>
        </>
      )}
    </div>
  );
}
